import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FiMenuFoldableMultiSelectItemSearchComponent } from './fi-menu-foldable-multi-select-item-search.component';
import { CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiMenuFoldableItemComponent } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-item/fi-menu-foldable-item.component';
import { MatButtonModule } from '@angular/material/button';
import { FiMenuMultiSelectItemSearchModule } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        CommonModule,
        CdkFixedSizeVirtualScroll,
        CdkVirtualScrollViewport,
        FiAppTextSharedModule,
        FiProfileIconModule,
        MatCheckboxModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        FiWhenScrolledModule,
        MatButtonModule,
        FiMenuMultiSelectItemSearchModule,
        InfoIconModule,
        MatRadioModule,
    ],
    declarations: [FiMenuFoldableMultiSelectItemSearchComponent, FiMenuFoldableItemComponent],
    exports: [FiMenuFoldableMultiSelectItemSearchComponent, FiMenuFoldableItemComponent],
})
export class FiMenuFoldableMultiSelectItemSearchModule {}
